export enum TradeAmountType {
	FIAT,
	ASSET
}
